import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import "./index.scss";

const SHOW_AFTER = 400;

// Pages scroll inside their own .text-zone (body has overflow: hidden),
// so we listen to that element rather than window.
const ScrollToTop = () => {
  const { pathname } = useLocation();
  const [zone, setZone] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = document.querySelector(".text-zone");
    setZone(el);
    setVisible(false);
    if (!el) return;

    const onScroll = () => setVisible(el.scrollTop > SHOW_AFTER);
    el.addEventListener("scroll", onScroll, { passive: true });
    return () => el.removeEventListener("scroll", onScroll);
  }, [pathname]);

  return (
    <button
      type="button"
      className={`scroll-to-top ${visible ? "visible" : ""}`}
      onClick={() => zone && zone.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Scroll to top"
      tabIndex={visible ? 0 : -1}
    >
      <FontAwesomeIcon icon={faArrowUp} />
    </button>
  );
};

export default ScrollToTop;
